import styled from 'styled-components'

export default styled.div`
  background: white;
  border-radius: 4px;
  border: 1px solid rgba(0,0,0,.15);
  box-shadow: 0 1px 6px rgba(0,0,0,.175);
  margin: 2px 0 0;
  font-size: 1rem;
  padding: 5px 0;
  position: absolute;
  right: 2px;
  top: 2px;
  user-select: none;
  z-index: 2;
`



// WEBPACK FOOTER //
// ./src/components/FloatingPaper/index.js